import { render, staticRenderFns } from "./addReaderRules.vue?vue&type=template&id=6bfb864a&scoped=true&"
import script from "./addReaderRules.vue?vue&type=script&lang=js&"
export * from "./addReaderRules.vue?vue&type=script&lang=js&"
import style0 from "./addReaderRules.vue?vue&type=style&index=0&id=6bfb864a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfb864a",
  null
  
)

export default component.exports